module.exports = __webpack_public_path__ + "img/5.0b9d7edb.png";